module.exports = __webpack_public_path__ + "img/About_Two.331cb89e.png";